<template>
    <div class="container-fluid">
        <top-bar
            :page="'CSSkillTree'"
            :leftText="character.name"
            v-if="character"
        />
        <SkillTree
            v-if="character"
            :initial="character"
            @updateSelectedAbilityList="updateSelectedAbilityList"
            @unlockAbility="unlockAbility"
            @forgetAbility="forgetAbility"
            class="pb-10 w-100"
        />
    </div>
    <footer
        class="footer fixed-bottom bg-dark text-light p-3 border-top border-secondary d-flex justify-content-end gap-2"
    >
        <router-link
            :to="{
                name: 'Character',
                params: { id: characterId },
            }"
            class="btn btn-secondary"
            ><font-awesome-icon
                icon="multiply"
                class="me-1"
            />Close</router-link
        >
    </footer>
</template>

<script>
import TopBar from "./TopBar.vue";
import { useRosterStore } from "../stores/index"; // Assuming you have a Vuex store
import SkillTree from "./SkillTree.vue";

export default {
    components: {
        TopBar,
        SkillTree,
    },
    name: "CSSkillTree",
    data() {
        return {
            skills: [],
            character: {},
            selectedAbilityList: null,
            readyToSave: false,
        };
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    methods: {
        addSkill(skill) {
            this.skills.push(skill);
        },
        async fetchCharacter() {
            const store = useRosterStore();
            try {
                // Assuming `getCharacterById` is a method in your store that returns a character by ID
                this.character = await store.getCharacterById(this.id);
                this.selectedAbilityList = this.character.archetype;
            } catch (error) {
                console.error("Failed to fetch character", error);
            }
        },
        updateSelectedAbilityList(abilityList) {
            this.selectedAbilityList = abilityList;
        },
        unlockAbility(ability) {
            if (!this.character.abilities) {
                this.character.abilities = [];
            }

            const exists = this.character.abilities.some(
                (a) => a.id === ability.id
            );
            if (!exists) {
                this.character.abilities.push(ability);
            }
        },

        forgetAbility(ability) {
            if (!this.character.abilities) return;

            this.character.abilities = this.character.abilities.filter(
                (a) => a.id !== ability.id
            );
        },
    },
    created() {
        this.fetchCharacter();
    },
    watch: {
        id: "fetchCharacter",
    },
};
</script>

<style scoped></style>

